import React from 'react';

export const useIsSafari = () => {
	const [isSafari, setIsSafari] = React.useState(false);

	React.useEffect(() => {
		const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		setIsSafari(isSafari);
	}, []);

	return {
		isSafari,
	};
};
